import './App.css';
import DashboardComponent from './components/dashboard/dashboard';
import LoginComponent from './components/login/Login';
import ErrorComponent from './components/error/error';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import AuthProvider, { useAuth } from './components/http/authcontex';
import ShowBanks from './components/bank/bank';
import AddBank from './components/bank/addBank';
import ShowSarfaesi from './components/sarfaesi/sarfaesi';
import AddSarfaesi from './components/sarfaesi/addSarfaesi';
import ShowSarfaesiAyAdmin from './components/sarfaesi/sarfaesiViewByAdmin';
import ShowPayment from './components/payment/payment';
import Report from './components/report/report';

function RoutAuth({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/" />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<LoginComponent />} />
            <Route path="/dashboard" element={
              <RoutAuth>
                <DashboardComponent />
              </RoutAuth>
            }
            />

            <Route path="/bank" element={
              <RoutAuth>
                <ShowBanks />
              </RoutAuth>

            }
            />
            <Route path="/editbank" element={
              <RoutAuth>
                <AddBank />
              </RoutAuth>

            }
            />
            <Route path="/addbank" element={
              <RoutAuth>
                <AddBank />
              </RoutAuth>

            }
            />

            <Route path="/payment" element={
              <RoutAuth>
                <ShowPayment />
              </RoutAuth>

            }
            />

            <Route path="/sarfaesibyadmin" element={
              <RoutAuth>
                <ShowSarfaesiAyAdmin />
              </RoutAuth>

            }
            />
            <Route path="/sarfaesi" element={
              <RoutAuth>
                <ShowSarfaesi />
              </RoutAuth>

            }
            />
            <Route path="/addSarfaesi" element={
              <RoutAuth>
                <AddSarfaesi />
              </RoutAuth>

            }
            />
            <Route path="/editSarfaesi" element={
              <RoutAuth>
                <AddSarfaesi />
              </RoutAuth>

            }
            />

            <Route path="/report" element={
              <RoutAuth>
                <Report/>
              </RoutAuth>

            }
            />


            <Route path="*" element={<ErrorComponent />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
